export default __webpack_public_path__ + "static/media/em_hat_3.ae24bf27.webp";